import { useCallback } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

import { useNetworkStatus } from 'technical/network/use-network-status';

export const useServiceWorkerUpdate = () => {
  const { isOnline } = useNetworkStatus();

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) {
        setInterval(() => registration.update(), 60 * 60 * 1000);
      }
    },
  });

  return {
    showUpdatePrompt: needRefresh && isOnline,
    applyUpdate: useCallback(
      () => updateServiceWorker(true),
      [updateServiceWorker],
    ),
    dismissUpdate: useCallback(() => setNeedRefresh(false), [setNeedRefresh]),
  };
};
